import React from 'react'

const usePageVisibility = () => {
	const [isPageVisible, setIsPageVisible] = React.useState(true)

	React.useEffect(() => {
		const handleVisibilityChange = () => {
			setIsPageVisible(!document.hidden)
		}

		document.addEventListener('visibilitychange', handleVisibilityChange)

		return () => {
			document.removeEventListener('visibilitychange', handleVisibilityChange)
		}
	}, [])

	return isPageVisible
}

export default usePageVisibility
